import clsx from 'clsx'
import Image from 'next/image'
import { useState } from 'react'

import { useAppSelector } from 'store/store'

import { selectAllGiftPackagesByProduct } from '@/entities/cart/selectors'

import { BASE_URL } from '@/shared/lib/const/env'
import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'

import { useGiftsCatalogModal } from '../../hooks/use-gifts-catalog-modal'
import { useGiftsWithProduct } from '../../hooks/use-gifts-with-product'
import { GiftsCatalogModal } from '../gifts-catalog-modal/gifts-catalog-modal'
import { GiftsPackagesModal } from '../gifts-packages-modal/gifts-packages-modal'

import cl from './gifts-with-product.module.scss'

type GiftsWithProductProps = {
	className?: string
	productId: number
}

const defaultTitle = <>Выбирайте подарок к&nbsp;покупке</>
// const defaultTitle = <>Выбирайте подарок к&nbsp;покупке, общей суммой до&nbsp;10&nbsp;000&nbsp;₽</>

export const GiftsWithProduct = (props: GiftsWithProductProps) => {
	const { className, productId } = props

	const { isModalOpen, closeModal, openModal } = useGiftsCatalogModal()
	const [isPackagesModalOpen, setPackagesModalOpen] = useState(false)
	const { one, all, selectedGift } = useGiftsWithProduct({ productId })
	const packages = useAppSelector(selectAllGiftPackagesByProduct(productId))

	const message = selectedGift ? selectedGift.TITLE : all?.length ? '' : defaultTitle
	const buttonText = selectedGift ? 'Заменить подарок' : 'Выбрать подарок'

	const imageClasses = clsx(cl.image, {
		[cl.image__hasGift]: selectedGift
	})

	if (!packages?.length && !one.length && !selectedGift) return null

	return (
		<>
			<div className={clsx(cl.root, className)}>
				<div className={imageClasses}>
					<div className={cl.image__gift}>
						<Image
							src="https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/features/cart/gift/gift.png"
							width={52}
							height={52}
							alt="Подарок"
						/>
					</div>
					{selectedGift && (
						<div className={cl.image__product}>
							<Image src={BASE_URL + selectedGift.IMAGE} width={52} height={52} alt="Подарок" />
						</div>
					)}
				</div>
				<div className={cl.content}>
					<Text weight="medium" className={cl.title}>
						Подарок к покупке
					</Text>
					{!!message && <Text className={cl.message}>{message}</Text>}
					{!!one?.length && one.length > 1 && (
						<Button theme="link" className={cl.button} onClick={openModal}>
							{buttonText}
						</Button>
					)}
					{!!packages?.length && packages?.length > 1 && one.length === 0 && !selectedGift && (
						<Button theme="link" className={cl.button} onClick={() => setPackagesModalOpen(true)}>
							{!all?.length ? `Выбрать подарки` : `Изменить подарок`}
						</Button>
					)}
					{!!all?.length && !selectedGift && one.length === 0 && (
						<div className={cl.appliedList}>
							{all.map(gift => (
								<div key={gift.ID} className={cl.appliedItem}>
									<div className={cl.appliedItem__img}>
										<Image src={BASE_URL + gift.IMAGE} width={40} height={40} alt={gift.TITLE} />
									</div>
									<div className={cl.appliedItem__title}>{gift.TITLE}</div>
								</div>
							))}
						</div>
					)}
				</div>
			</div>
			<GiftsCatalogModal productId={productId} isOpen={isModalOpen} onClose={closeModal} gifts={one || []} />
			<GiftsPackagesModal
				productId={productId}
				isOpen={isPackagesModalOpen}
				onClose={() => setPackagesModalOpen(false)}
			/>
		</>
	)
}
